import React from 'react';
import TextField from '../../../components/common/TextField';
import { formatNumber, getTotal } from '../../../common/Util';
import Typography from '../../../components/common/Typography';

const HousingItemSection = ({ title, dataList, inputList = [], total }) => {
  const totalValue = input => {
    if (total) {
      return input.key == 'total' ? total : formatNumber(dataList[input.key] || '0');
    }

  // input.key가 배열인 경우 getTotal 함수 사용
  if (Array.isArray(input.key)) {
    return formatNumber(getTotal([dataList], input.key));
  }

    return formatNumber(dataList[input.key] || '0');
  };

  return (
    <div className="housingItemSection">
      <Typography variant="body2Bold">{title}</Typography>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        {inputList.map((input, index) => (
          <TextField
            key={index}
            {...input}
            size="small"
            name={input.key}
            onChange={() => {}}
            value={totalValue(input)}
            disabled={input.color != 'secondary'}
          />
        ))}
      </div>
    </div>
  );
};

export default HousingItemSection;
